import * as api from '../api'

//Action Creators
export const getTenancies = () => async (dispatch) => {
  try {
    const { data } = await api.fetchTenancies()
    dispatch({ type: 'FETCH_TENANCIES', payload: data })
  } catch (error) {
    dispatch({
      type: 'API_ERROR',
      payload: error.response.data.message,
    })
  }
}
